import React, { useEffect }  from 'react'
import { SwatchesPicker } from 'react-color'
import { makeStyles } from '@material-ui/core/styles'
import Popover from '@material-ui/core/Popover'
import FormatColorFill from '@material-ui/icons/FormatColorFill'


const useStyles = makeStyles((theme) => ({
  root:{
    cursor: 'pointer',
  }
}));

export const ColorPicker = (props) => { 

  const classes = useStyles()

  const [anchorEl, setAnchorEl] = React.useState(null);
  
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  useEffect(() => {          
    
  }, [])

  return(
    <div>
        <div 
          // style={{backgroundColor: '#ccc'}}
          onClick={handleClick} 
          className={classes.root} >
              <FormatColorFill/>
        </div>

        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}               
        >
          <SwatchesPicker onChange={props.eventOnChange} />
        </Popover>
    </div>
  )
}